import {getHostVariables} from '../../utils';
import {COMPONENT_NAME_PROP, COMPONENT_NAME_ATTR} from '../../constants';
import {PROPS} from '../../symbols';

export function getComponentName(el) {
	const hostVariables = getHostVariables(el);
	return hostVariables[PROPS] && hostVariables[PROPS].hasOwnProperty(COMPONENT_NAME_PROP)
		? hostVariables[PROPS][COMPONENT_NAME_PROP]
		: el[COMPONENT_NAME_PROP] || el.getAttribute(COMPONENT_NAME_ATTR);
}
